export const cols = [{
	prop: 'createdate',
	label: '下单时间',
	// width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'ordernumber',
	label: '订单编号',
	// width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'cusname',
	label: '客户名称',
	// width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'needpaymoney',
	label: '应付款',
	// width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'beenpaidmoney',
	label: '已付款',
	// width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'waitpaymoney',
	label: '未支付金额',
	// width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'creditlimit',
	label: '使用信用额度',
	// width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymode',
	label: '支付方式',
	// width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'invoiceStatus',
	label: '开票状态',
	// width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'invoiceTime',
	label: '开票成功时间',
	ischoose: false,
	align: 'center'
}, {
	prop: 'invoiceNo',
	label: '发票号',
	ischoose: false,
	align: 'center'
}]
